import { elements } from '@elements';
import useEmailEditor from '@hooks/useEmailEditor';
import { Box, ButtonBase, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function Block({ type }) {
    const { t } = useTranslation();
    const { setDraggedElement } = useEmailEditor();
    const Icon = elements[type].blockIcon;
    const label = t(elements[type].blockLabel);

    const onDragStart = (event: React.DragEvent, type: String) => {
        setDraggedElement(type);
        event.dataTransfer.setData('add-block/' + type, '');
    };

    return (
        <Box
            draggable
            onDragStart={event => onDragStart(event, type)}
            onDragEnd={() => setDraggedElement(null)}
            component={ButtonBase}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: 76,
                height: 76,
                padding: 1,
                borderRadius: 2,
                border: 1,
                borderColor: 'divider',
                color: 'text.secondary',
                // https://stackoverflow.com/q/22922761
                transform: 'translate(0, 0)',
                '&:hover': {
                    backgroundColor: 'action.hover',
                },
                cursor: 'grab',
                boxShadow: theme => `0px 0px 5px 0px ${theme.palette.divider}`,
            }}
        >
            {Icon && <Icon fontSize="large" />}
            <Typography
                variant="caption"
                textTransform="capitalize"
                fontWeight="bold"
            >
                {label}
            </Typography>
        </Box>
    );
}

export default Block;
